<mat-card appearance="raised">
  <mat-card-header class="card-header">
    <mat-card-title class="card-header__title">
      {{data?.account?.entityName}}
    </mat-card-title>
  </mat-card-header>
  <mat-card-content class="no-bottom-padding">
    <mat-list>
      <mat-list-item>
        <mat-icon matListItemIcon>business</mat-icon>
        <span matListItemTitle>
          <a class="default-link"
             (click)="openCompanyDetails()">{{data?.account?.entityName || ''}}
            <br />{{data?.account?.entityNumber || ''}}
          </a>
        </span>
        <span matListItemLine>Company</span>
      </mat-list-item>
      <mat-list-item>
        <mat-icon matListItemIcon>work</mat-icon>
        <span matListItemTitle>{{data?.account?.entityDBA || '-'}}</span>
        <span matListItemLine>DBA</span>
      </mat-list-item>
      <mat-list-item>
        <mat-icon matListItemIcon>location_on</mat-icon>
        <span matListItemTitle>{{data?.account?.entityAddress?.line1}}</span>
        <span matListItemLine>{{data?.account?.entityAddress?.city}},
          {{data?.account?.entityAddress?.state}}
          {{data?.account?.entityAddress?.zip}}
        </span>
        <span *ngIf="data?.account?.entityAddress?.line2"
              matListItemLine>{{data?.account?.entityAddress?.line2}}
        </span>
      </mat-list-item>
      <mat-list-item>
        <mat-icon matListItemIcon>receipt</mat-icon>
        <span matListItemTitle>{{data?.account?.entityEIN}}</span>
        <span matListItemLine>Tax ID</span>
      </mat-list-item>
      <mat-list-item>
        <mat-icon matListItemIcon>phone</mat-icon>
        <span matListItemTitle>{{data?.account?.entityPhone || '-'}}</span>
        <span matListItemLine>Primary phone</span>
      </mat-list-item>
    </mat-list>
  </mat-card-content>
</mat-card>